import { ChartSnapshot } from 'features/spectrumChart/types';
import { Snapshot } from 'types';
import { useEffect, useState } from 'react';
import { getFrequencyArray } from 'utils/FreqUtils';

interface Props {
  snapshot: Snapshot | ChartSnapshot | undefined;
  traceLength: number;
}

export const useChartLabels = ({ snapshot, traceLength }: Props) => {
  const [yLabels, setYLabels] = useState<string[]>([]);
  const [xLabels, setXLabels] = useState<string[]>([]);
  const [snapshotFrequencies, setSnapshotFrequencies] = useState<string[]>([]);

  useEffect(() => {
    if (!snapshot?.reference || !snapshot.scale) return;

    const labels = [];
    for (let i = 0; i < 10; i++) {
      const label = snapshot.reference - snapshot.scale * i;
      labels.push(label.toString());
    }
    setYLabels(labels);
  }, [snapshot?.reference, snapshot?.scale]);

  useEffect(() => {
    if (
      snapshot?.center === undefined ||
      snapshot?.span === undefined ||
      snapshot?.lo === undefined ||
      snapshot?.lo_mode === undefined
    )
      return;

    const length = traceLength <= 1 ? 601 : traceLength;
    const frequencies = getFrequencyArray(
      snapshot.center,
      snapshot.span,
      length,
      snapshot.lo,
      snapshot.lo_mode,
      false
    );

    setSnapshotFrequencies(frequencies);
    const centerUnit = snapshot?.center?.split(' ')[1] || ' MHz';
    const center =
      frequencies[Math.floor((frequencies.length - 1) / 2)] + ` ${centerUnit}`;

    setXLabels([
      frequencies[0] || '?',
      center || '?',
      frequencies[frequencies.length - 1] || '?',
    ]);
  }, [
    snapshot?.center,
    snapshot?.span,
    snapshot?.lo,
    snapshot?.lo_mode,
    traceLength,
  ]);

  return [snapshotFrequencies, xLabels, yLabels];
};
